import { Route } from 'vue-router'

import { ENTITY_PARAM_KEYS, FIND_PATTERN } from './constants'
import { AdditionalReplacerData } from "./types";

export let customReplacer: AdditionalReplacerData | null = null

export const matchedRouteParams = (route: Route) => route.fullPath.match(FIND_PATTERN)

export const hasMatchedRouteParams = (route: Route) => route.fullPath.match(FIND_PATTERN) !== null

export const prepareAnchorLink = (fullPath:string, route: Route):string => {
  const params = route.params
  let newRoute = fullPath

  for (const [ param, value ] of Object.entries(params)) {
    const foundedParam = ENTITY_PARAM_KEYS.find(key => key === param)

    if (foundedParam !== undefined) {
      newRoute = newRoute.replace(value, foundedParam)
    }
  }

  if (customReplacer !== null && !!customReplacer.replacerFn) {
    newRoute = customReplacer.replacerFn(newRoute, route)
  }

  return newRoute
}

export const initAdditionalReplacer = (info: AdditionalReplacerData) => {
  customReplacer = { replacerFn: info?.replacerFn, onWizardFinish: info?.onWizardFinish }
}

export const resetCustomReplacer = () => {
  customReplacer = null
}
